import './styles/netPosition.scss';
import { useEffect } from 'react';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { useEnableNetPositionFeature } from './useEnableNetPositionFeature';
import { useFetchNetPosition } from './useFetchNetPosition';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { useStore } from '@/store/useStore';

/**
 * Inner worker: only mounted when the feature is enabled so the polling/queue
 * machinery (and net-position fabric calls) never run for non-CA users.
 */
const NetPositionWorker = () => {
  const { shouldShow, netPosition } = useFetchNetPosition();
  const orientation = useAppOrientation();
  const gameLoadSuccess = useStore((s) => s.gameStatus.gameLoadSuccess);
  const gameWindowOpen = useStore((s) => s.gameWindowContext.gameWindowOpen);

  useEffect(() => {
    Logger.logRumAction({
      name: 'net_position',
      description: 'Net position enabled',
      useCase: DdEventCategory.UserInteraction,
      eventType: DdEventType.Action,
      context: { type: 'NET_POSITION' },
    });
  }, []);

  if (!shouldShow || !gameLoadSuccess || gameWindowOpen) {
    return null;
  }

  return (
    <div
      className={`net-position-module ${orientation === 'portrait' ? 'portrait' : ''}`}
      data-testid="net-position-module"
    >
      <span>WIN/LOSS: </span>
      <span>{netPosition}</span>
    </div>
  );
};

/**
 * Canada net-position readout, gated by {@link useEnableNetPositionFeature}
 * (country/provider/experiment) so the worker — and its fabric polling — only
 * mounts for eligible sessions.
 */
export const NetPositionOverlay = () => {
  const { netPositionFeatureEnabled } = useEnableNetPositionFeature();

  if (!netPositionFeatureEnabled) {
    return null;
  }

  return <NetPositionWorker />;
};

export default NetPositionOverlay;
